import React, { useState } from 'react'
//Hooks
import { useForm } from 'react-hook-form';
//Servicios
import CursoService from '../../../services/CursoService';
//Componentes
import Modal from '../../../components/common/Modal'
import Form from '../../../components/common/Form';
import Button, { CustomButton } from '../../../components/common/Button';
import Input from '../../../components/common/Input';
import Error from '../../../components/common/Error';
import Success from '../../../components/common/Success';
//Imágenes
import { PlusSquare } from 'react-feather';

function CrearCurso({ refresh }) {
    //Estados
    const [cursoModal, setCursoModal] = useState(false);
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    //Manipuladores
    function handleToggleModal() {
        setCursoModal(!cursoModal);
        reset();
        setSuccess('');
    }

    //React Hook Form
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    //Handle Submit
    const onSubmit = (data) => {
        setLoading(true);
        CursoService.crearCurso(data).then((res) => {
            setSuccess(res.message);
            refresh();
            setLoading(false);
        }).catch((error) => {setError(error.data.message);setLoading(false)});
        reset();
    }

    return (
        <>
            <CustomButton onClick={handleToggleModal} padding='24px' width='20%' boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25);'><PlusSquare />Crear nuevo curso</CustomButton>
            <Modal state={cursoModal} setState={handleToggleModal} title='Crear nuevo curso' textAlign='left'>
                {!success &&
                    <Form onSubmit={handleSubmit(onSubmit)} width='100%' padding='16px 32px' boxShadow='none'>
                        <Input
                            register={register}
                            name='nombreCurso'
                            required={{ required: "El nombre del curso es obligatorio" }}
                            placeholder="Ingresa el nombre del curso"
                            error={errors.nombreCurso}
                        />
                        <Button type='submit' margin='8px 0px 0px 0px ' loading={loading}><PlusSquare />Crear</Button>
                        <Error message={error}></Error>
                    </Form>
                }
                <Success message={success}></Success>
            </Modal>
        </>
    )
}

export default CrearCurso